import { User } from "../../common/models/User";
import { UserResponse } from "../models/responses/UserResponse";

export const UserMapper = (data: UserResponse): User => {
  return {
    id: data._id,
    email: data.email,
    firstname: data.firstname,
    lastname: data.lastname,
    phone: data.phone,
    roles: data.roles
  }
}